import { render, staticRenderFns } from "./ShopAll.vue?vue&type=template&id=3b1bcf7c&scoped=true"
import script from "./ShopAll.vue?vue&type=script&lang=ts"
export * from "./ShopAll.vue?vue&type=script&lang=ts"
import style0 from "./ShopAll.vue?vue&type=style&index=0&id=3b1bcf7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1bcf7c",
  null
  
)

export default component.exports